<template>
  <div class="dynamic-page-wrapper">
    <div class="page-dynamic-content flex-col">
      <div id="gladly-help-center" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { contentstackRequest } from '../util/contentstack/api';
import { metaGen } from '~/util/metadata';
import { getFirstIndex } from '~/util/arrays';
import { QueryTypes } from '~/server/utils/contentstack';
import { useRootStore } from '~/store';

const { locale } = useI18n();
const event = useRequestEvent();

const { data: asyncData, error: asyncError } = await useAsyncData(async () => {
  const contentStackData = await contentstackRequest(QueryTypes.page, '/help-center', {
    event,
    query: { locale: locale?.value },
  });
  if (!contentStackData) throw createError({ statusCode: 404, message: 'Page not found' });
  const page = getFirstIndex(contentStackData?.data?.all_page?.items);
  if (!page) throw createError({ statusCode: 404, message: 'Page not found' });
  return {
    contentStackData,
    page,
  };
});

useAsyncErrorHandling({
  error: asyncError.value,
});

const rootStore = useRootStore();
useHead({
  ...(metaGen(rootStore?.brandSettings, {
    ...(asyncData.value?.page?.seo || {}),
  }) as any),
});

onBeforeMount(() => {
  (window as any).gladlyHCConfig = {
    api: 'https://solostove.us-1.gladly.com',
    orgId: 'EW1TQ9vdQQCZGISyy_TR-g',
    brandId: 'dRdmagUCQ5eoB7tDHGPRqg',
    cdn: 'https://cdn.gladly.com',
    selector: '#gladly-help-center',
  };
  loadGladly();
});

function loadGladly() {
  const t = document;
  const e = t.createElement('script');
  e.type = 'text/javascript';
  e.async = true;
  e.src = 'https://cdn.gladly.com/help-center/hcl.js';
  const a = t.getElementsByTagName('script')[0];
  if (a) {
    a.parentNode?.insertBefore(e, a);
  }
}
</script>

<style lang="scss">
#gladly-help-center {
  margin-top: 1rem;
  @include local-mixins.tablet_and_mobile {
    max-width: 90vw;
  }
}
.gladlyHC-faqSection-listItem,
.gladlyHC-answersIndex-link {
  margin-bottom: 8px;
  a {
    color: $color-neutral-cool-900;
  }
}
.gladlyHC-answerDetail-content {
  ul,
  div {
    margin-bottom: 8px;
  }
}
</style>

<style lang="scss" scoped>
.content-block.page-title {
  margin: 0 auto;

  @include local-mixins.desktop {
    max-width: local-functions.rem-calc(906);
  }
  @include local-mixins.tablet_and_mobile {
    max-width: calc(100% - local-vars.$mob-margin * 2);
    padding: 0 1rem;
    overflow: auto;
  }
  @include local-mixins.tablet {
    margin: 0 local-functions.rem-calc(120);
  }
}
</style>
